import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2849dec8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "报修内容", -1));
const _hoisted_3 = {
  class: "store"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报修门店", -1));
const _hoisted_5 = {
  class: "black"
};
const _hoisted_6 = {
  class: "location"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报修点位", -1));
const _hoisted_8 = {
  class: ""
};
const _hoisted_9 = {
  class: "rowBox"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报修人", -1));
const _hoisted_11 = {
  class: "rowBox"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系方式", -1));
const _hoisted_13 = {
  class: "storeBox"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是否紧急", -1));
const _hoisted_15 = {
  class: "rowBox btm"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "需求描述", -1));
const _hoisted_17 = {
  class: "imgUp"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 照片墙 ", -1));
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "btnBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_button = _resolveComponent("el-button");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($setup.storeName), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString($setup.storeLocationName), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_input, {
    style: {
      "width": "70%"
    },
    modelValue: $setup.nameInput,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.nameInput = $event),
    placeholder: "请输入"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_input, {
    style: {
      "width": "70%"
    },
    modelValue: $setup.mobileInput,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.mobileInput = $event),
    placeholder: "请输入"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_switch, {
    modelValue: $setup.flag,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.flag = $event),
    size: "large"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_el_input, {
    style: {
      "width": "70%"
    },
    modelValue: $setup.remarkInput,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.remarkInput = $event),
    rows: 3,
    type: "textarea",
    placeholder: "请输入"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", null, [_createVNode(_component_el_upload, {
    "file-list": $setup.uploadTableData.fileList,
    "list-type": "picture-card",
    "on-preview": $setup.handlePictureCardPreview,
    "on-remove": $setup.handleRemove,
    limit: 3,
    ref: "uploadTable",
    action: $setup.uploadTableData.signatureData.host,
    "before-upload": $setup.handleStoreBeforeUpload,
    "on-exceed": $setup.handleExceed,
    "before-remove": $setup.handleBeforeRemove,
    "on-success": $setup.handleStoreOnSuccess,
    data: $setup.uploadTableData.data,
    accept: "image/*"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })]),
    _: 1
  }, 8, ["file-list", "on-preview", "on-remove", "action", "before-upload", "on-exceed", "before-remove", "on-success", "data"]), _createVNode(_component_el_dialog, {
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.dialogVisible = $event),
    class: "imgPreview",
    style: {
      "width": "90vw"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      "w-full": "",
      src: $setup.dialogImageUrl,
      alt: "Preview Image"
    }, null, 8, _hoisted_19)]),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_20, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
    class: "defaultBtn",
    color: "#000",
    onClick: _cache[5] || (_cache[5] = $event => $setup.submitApi())
  }, {
    default: _withCtx(() => [_createTextVNode("提交")]),
    _: 1
  })), [[_directive_loading, $setup.fullscreenLoading, void 0, {
    fullscreen: true,
    lock: true
  }]]), _createVNode(_component_el_button, {
    class: "defaultBtn"
  }, {
    default: _withCtx(() => [_createTextVNode("取消")]),
    _: 1
  })])]);
}